import { Box, Button, Grid, TextField } from "@mui/material";
import AudioS3 from "components/audio/AudioS3";
import Modal from "components/modal/Modal";
import datetimeHelper from "helper/datetime-helper";
import moment from "moment";

const ModalInboundCalllDetail = ({ open, onClose, currentRecord }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Chi tiết cuộc gọi vào"
      maxWidth="sm">
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sx={{
            "& audio": {
              width: "100%",
            },
          }}>
          <AudioS3
            linkS3={currentRecord?.recordFileS3}
            link={currentRecord?.recordFile}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Số điện thoại gọi"
            value={currentRecord?.fromNumber || ""}
            variant="standard"
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Số điện thoại nhận"
            value={currentRecord?.toNumber || ""}
            variant="standard"
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Điện thoại viên thực hiện"
            value={currentRecord?.agent?.user?.fullname || ""}
            variant="standard"
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Số máy lẻ"
            value={currentRecord?.extension?.name || ""}
            variant="standard"
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Thời gian gọi"
            value={
              currentRecord?.startedAt
                ? moment(currentRecord.startedAt).format("YYYY-MM-DD HH:mm:ss")
                : ""
            }
            variant="standard"
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Trạng thái"
            value={currentRecord?.status || ""}
            variant="standard"
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Thời gian trả lời"
            value={datetimeHelper.secondToHHMMSS(
              currentRecord?.answeredDuration
            )}
            variant="standard"
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Thời gian kết nối"
            value={datetimeHelper.secondToHHMMSS(currentRecord?.duration)}
            variant="standard"
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Người kết thúc"
            value={currentRecord?.hangupBy || ""}
            variant="standard"
          />
        </Grid>
      </Grid>
      <Box mt={2} display="flex" justifyContent="flex-end">
        <Button onClick={onClose} variant="contained">
          Thoát
        </Button>
      </Box>
    </Modal>
  );
};

export default ModalInboundCalllDetail;
